/// <reference path="typings/swiper.d.ts" />
/// <reference path="typings/jquery.d.ts" />
/**
 * Thumbnail objesi oluşturmaya yarar. Site içerisinde herhangi bir sayfadaki thumbnailler bu class üzerinden oluşturulmaktadır.
 * @class SwiperObjects
 */
var SwiperObjects = /** @class */ (function () {
    /**
     * @memberOf SwiperObjects
     * @method constructor
     * @desc {@link SwiperObjects} oluşturulduğunda otomatik olarak document içerisinde
     * thumbnail-slider-container class isimlendirmesini içeren elementleri thumbnailSliders değişkeni içerisine atar.
     */
    function SwiperObjects() {
        this.thumbnailSliders = document.querySelectorAll('.thumbnail-slider-container[class*="swiper-"]');
        this.sliderSection = document.getElementById('schedule');
        if (this.sliderSection) {
            this.daysArray = [
                { "dayID": "#pazartesi", "dayName": "Pazartesi" },
                { "dayID": "#sali", "dayName": "Salı" },
                { "dayID": "#carsamba", "dayName": "Çarşamba" },
                { "dayID": "#persembe", "dayName": "Perşembe" },
                { "dayID": "#cuma", "dayName": "Cuma" },
                { "dayID": "#cumartesi", "dayName": "Cumartesi" },
                { "dayID": "#pazar", "dayName": "Pazar" }
            ];
            this.prevDayNode = document.getElementById('prevDaySwiper');
            this.nextDayNode = document.getElementById('nextDaySwiper');
            this.createScheduleSlider();
        }
    }
    SwiperObjects.prototype.createScheduleSlider = function () {
        var scheduleSwiper = new Swiper('.swiper-schedule', {
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            loop: false
        });
        var currentIndex = scheduleSwiper.activeIndex;
        this.updateSchedulePaginationNames(currentIndex);
        var dayTabs = document.getElementsByClassName('tab-pane');
        var _this = this;
        Object.keys(dayTabs).forEach(function (key) {
            if (dayTabs[key].classList.contains('active')) {
                if (key.length === 1) {
                    _this.activeDayIndex = key;
                }
            }
        });
        scheduleSwiper.slideTo(this.activeDayIndex);
        this.setScheduleListener(scheduleSwiper);
    };
    SwiperObjects.prototype.setScheduleListener = function (scheduleSwiper) {
        var _this = this;
        scheduleSwiper.on('slideChangeEnd', function () {
            var currentIndex = scheduleSwiper.activeIndex;
            _this.updateSchedulePaginationNames(currentIndex);
            var tabObject = '#schedule a[href="' + _this.daysArray[currentIndex].dayID + '"]';
            $(tabObject).tab('show');
        });
    };
    SwiperObjects.prototype.updateSchedulePaginationNames = function (currentIndex) {
        var _this = this;
        if (currentIndex === 0) {
            _this.prevDayNode.textContent = "";
            _this.nextDayNode.textContent = _this.daysArray[(currentIndex + 1)].dayName;
        }
        else if (currentIndex === 6) {
            _this.nextDayNode.textContent = "";
            _this.prevDayNode.textContent = _this.daysArray[(currentIndex - 1)].dayName;
        }
        else {
            _this.prevDayNode.textContent = _this.daysArray[(currentIndex - 1)].dayName;
            _this.nextDayNode.textContent = _this.daysArray[(currentIndex + 1)].dayName;
        }
    };
    /**
     * @memberOf SwiperObjects
     * @desc Anasayfa slider elementinin oluşturulmasını sağlar.
     */
    SwiperObjects.prototype.createHomeSlider = function () {
        new Swiper('.home-slider-container', {
            nextButton: '.slider-next',
            prevButton: '.slider-prev',
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            freeMode: false,
            pagination: '.slider-pagination',
            paginationClickable: true,
            autoplay: 14000,
            autoplayDisableOnInteraction: false
        });
    };
    /**
     * @memberOf SwiperObjects
     * @desc Bu fonksiyon Thumbnail objelerinin dinamik olarak oluşturulmasını sağlamaktadır.
     * Bu şekilde kaç adet swiper objesi varsa bunlar için ilgili parametreler oluşturulmaktadır.
     * İlgili parametreleri alarak {@link SwiperObjects#createThumbnail} fonksiyonunu çağırmaktadır.
     */
    SwiperObjects.prototype.getThumbnailObjects = function () {
        var _this = this;
        var thumbnailSliders = _this.thumbnailSliders;
        if (thumbnailSliders.length !== 0 && thumbnailSliders[0].classList[2]) {
            Object.keys(thumbnailSliders).forEach(function (key) {
                var funcNumbers = thumbnailSliders[key].classList[2].match(/\d/g);
                var type = parseInt(funcNumbers[0]);
                var slidesView = parseInt(funcNumbers[1]);
                var ID = parseInt(funcNumbers[2]);
                _this.createThumbnail(type, slidesView, ID);
            });
        }
    };
    /**
     * @memberOf SwiperObjects
     * @desc Thumbnail objeleri ilgili class üzerinden alındıktan sonra gelen tipine göre
     * dinamik olarak elementin oluşturulması sağlanır.
     *
     * @param {number} type - Sliderin tipinin ne olduğunu belirtir. Bu sayede tablet ve mobil ekran görüntülenecek slider sayıları belirlenmiş olur
     * <b>type 1;</b>
     * mobil Slider sayısı = 2.5
     * tablet Slider sayısı = 3
     * <b>type 2;</b>
     * mobil Slider sayısı = 1.25
     * tablet Slider sayısı = 3
     * <b>type 3;</b>
     * mobil Slider sayısı = 1.25
     * tablet Slider sayısı = 2
     *
     * @param {number} slidesView - Desktop görünümünde kaç adet slider görüntüleneceğini belirtir
     * @param {number} ID - Swiper elementlerinin bağımsız olarak tanımlanması için rastgele bir değer verilerek oluşturulan parametredir.
     */
    SwiperObjects.prototype.createThumbnail = function (type, slidesView, ID) {
        var mobileView;
        var tabletView;
        var slidesPerColumnDesktop;
        var slidesPerColumnMobile;
        switch (type) {
            case 1:
                mobileView = 2.5;
                tabletView = 3;
                slidesPerColumnDesktop = 1;
                slidesPerColumnMobile = 1;
                break;
            case 2:
                mobileView = 1.25;
                tabletView = 3;
                slidesPerColumnDesktop = 1;
                slidesPerColumnMobile = 1;
                break;
            case 3:
                mobileView = 1.25;
                tabletView = 2;
                slidesPerColumnDesktop = 1;
                slidesPerColumnMobile = 1;
                break;
            case 4:
                mobileView = 2.25;
                tabletView = 4;
                slidesPerColumnDesktop = 2;
                slidesPerColumnMobile = 1;
                break;
        }
        new Swiper('.swiper-' + type + '-' + slidesView + '-' + ID, {
            slidesPerView: slidesView,
            slidesPerColumn: slidesPerColumnDesktop,
            spaceBetween: 16,
            pagination: '.swiper-pagination',
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            slidesPerGroup: slidesView,
            freeMode: false,
            paginationClickable: true,
            simulateTouch: false,
            slidesPerColumnFill: 'row',
            breakpoints: {
                992: {
                    slidesPerView: tabletView,
                    simulateTouch: false,
                    slidesPerColumn: slidesPerColumnMobile
                },
                758: {
                    slidesPerView: mobileView,
                    simulateTouch: true,
                    freeMode: true,
                    slidesPerColumn: slidesPerColumnMobile
                }
            }
        });
    };
    return SwiperObjects;
}());
var swiperElements = new SwiperObjects();
swiperElements.createHomeSlider();
swiperElements.getThumbnailObjects();
//# sourceMappingURL=swipers.js.map